'use client'

import { Link, usePathname } from '@/navigation'
import clsx from 'clsx'
import React from 'react'

export default function Item({
  icon,
  label,
  href,
  onClick,
  ...rest
}: {
  icon: React.ReactNode
  label?: React.ReactNode
  href?: string
  onClick?: React.MouseEventHandler<HTMLElement>
}) {
  const pathname = usePathname()

  const child = (
    <>
      {icon}
      {label ? <span>{label}</span> : null}
    </>
  )

  if (href) {
    return (
      <Link
        className={clsx(
          'mobile-nav__item',
          pathname === href && 'mobile-nav__item--selected'
        )}
        href={href}
      >
        {child}
      </Link>
    )
  }

  return (
    <button className='mobile-nav__item' onClick={onClick} {...rest}>
      {child}
    </button>
  )
}
